<template>
  <v-treeview
    id="file-explorer"
    v-model="tree"
    :return-object="true"
    class="pa-2"
    :items="items"
    :selectable="selectable"
    :activatable="activatable"
    item-key="path"
    :open-on-click="openOnClick"
    dense
    style="overflow-x: scroll"
    @input="itemSelected"
  >
    <!-- {{ tree }} -->
    <template v-slot:prepend="{ item, open }">
      <div
        @click="click(item)"
        @dblclick="dblClick(item)"
      >
        <template v-if="item.ext !== undefined">
          <v-icon v-if="item.ext == '.zip'">
            {{ "mdi-file-star" }}
          </v-icon>
          <v-img
            v-else-if="item.mime.includes('image')"
            contain
            max-width="24"
            max-height="24"
            :lazy-src="item.path"
            :src="item.path"
          />
          <v-icon v-else>
            {{ fileIcon[item.mime] }}
          </v-icon>
        </template>

        <template v-else>
          <v-icon v-if="item.type == 'dir'">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          <v-icon v-else>
            {{ fileIcon[item.mime] }}
          </v-icon>
        </template>
      </div>
    </template>
    <template
      slot="label"
      slot-scope="{ item }"
    >
      <div
        @click="click(item)"
        @dblclick="dblClick(item)"
      >
        {{ item.name }}
      </div>
    </template>
  </v-treeview>
</template>

<script>
// Tools
const ft = require("../Tools/FileTools");

export default {
  props: {
    dir: {
      type: String,
      required: true,
    },
    filter: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    openOnClick: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [],
      tree: [],
      fileIcon: {
        "application/pdf": "mdi-file-pdf-box",
        "application/zip": "mdi-archive-settings",
        "video/mp4": "mdi-file-video",
        "video/webm": "mdi-file-video",
      },
    };
  },
  watch: {
    reset: function () {
      this.tree = [];
      this.scan();
    },
  },
  created() {
    this.scan();
  },
  methods: {
    itemSelected() {
      if (this.selectable) {
        this.$emit("item-selected", this.tree);
      }
    },
    click(val) {
      if (!val.mime.includes("directory")) {
        if (this.tree.includes(val)) {
          this.tree.splice(this.tree.indexOf(val), 1);
        } else {
          this.tree.push(val);
        }

        if (!this.selectable) {
          if (this.tree.length > 0) {
            this.tree = [this.tree[this.tree.length - 1]];
          }
        }

        this.$emit("item-selected", this.tree);
      } else {
        // Send dirpath
        this.$emit("item-selected", [val]);
      }
    },
    dblClick(val) {
      // TODO: Need to open / send data directly and close the dialog
      this.$emit("dblclick", val);
    },
    scan() {
      ft.scan(this.dir, this.filter, []).then((files) => {
        this.items = files;
        this.sortItems();
      });
    },
    sortItems() {
      // Sort first dirs and files after
      this.items = this.items.sort(function (a, b) {
        if (a.type == "dir" && b.type == "file") {
          return -1;
        }
        if (a.type == "file" && b.type == "dir") {
          return 1;
        }
      });
    },
  },
};
</script>

<style>
#file-explorer {
  height: 33vh;

  border-radius: 3px;

  overflow-y: auto;
}

#file-explorer .v-treeview-node {
  cursor: pointer;
}

.theme--dark.v-treeview--hoverable .v-treeview-node__root:hover::before,
.theme--dark#file-explorer .v-treeview-node--click > .v-treeview-node__root:hover::before {
  opacity: 0.05;
}

.theme--dark#file-explorer {
  background-color: #323232;
}

.theme--light#file-explorer {
  background-color: #efefef;
}
</style>
